import { INavItem } from "@front/m19-ui";

export type { INavItem };

export class NavItem implements INavItem {
  id: string;
  label: string;
  onlyBeta: boolean;
  children?: NavItem[];
  href?: string;
  icon?: INavItem["icon"];
  url?: string;

  constructor(navItem: INavItem) {
    this.icon = navItem.icon;
    this.label = navItem.label;
    this.id = navItem.id;
    this.url = navItem.url;
    this.href = navItem.href;
    this.children = navItem.children?.map((child) => new NavItem(child));
    this.onlyBeta = !!navItem.onlyBeta;
  }
}
